
    /**
     * @description
     *  Lista de métodos HTTP (no verbos, ya que OPTIONS es un sustantivo).
     */

export enum HTTPMethod {

    CONNECT,
    DELETE,
    GET,
    HEAD,
    OPTIONS,
    PATCH,
    POST,
    PUT,
    TRACE
}
